import { apolloClient } from '@stores'
import { GET_SALES_PERIODS } from '../graphql/getSalesPeriods'
import { CREATE_SALES_PERIOD } from '../graphql/createSalesPeriod'
import { UPDATE_SALES_PERIOD } from '../graphql/updateSalesPeriod'
import { DELETE_SALES_PERIOD } from '../graphql/deleteSalesPeriod'

export class SalesPeriodSettingsDataStore {
  getSalesPeriods = async (bsgId: string) => {
    const response = await apolloClient.query({
      query: GET_SALES_PERIODS,
      variables: {
        buyingSessionGroupId: bsgId
      },
      fetchPolicy: 'network-only'
    })
    return {
      salesPeriods: response?.data?.findVIPSalesPeriod?.Items,
      loading: response?.data?.loading
    }
  }

  createSalesPeriod = async (
    bsgId: string,
    startDate: string,
    endDate: string,
    name: string
  ) => {
    const response = await apolloClient.mutate({
      mutation: CREATE_SALES_PERIOD,
      variables: {
        buyingSessionGroupId: bsgId,
        startDate: startDate,
        endDate: endDate,
        name: name
      }
    })
    return {
      data: response?.data
    }
  }

  updateSalesPeriod = async (
    salesPeriodId: string,
    startDate: string,
    endDate: string
  ) => {
    const response = await apolloClient.mutate({
      mutation: UPDATE_SALES_PERIOD,
      variables: {
        salesPeriodId: salesPeriodId,
        startDate: startDate,
        endDate: endDate
      }
    })
    return {
      data: response?.data
    }
  }

  deleteSalesPeriod = async (salesPeriodId: string) => {
    const response = await apolloClient.mutate({
      mutation: DELETE_SALES_PERIOD,
      variables: {
        salesPeriodId: salesPeriodId
      }
    })
    return {
      data: response?.data
    }
  }
}
